import React from 'react';
import { newId } from './newid';

// Todo: add autocomplete to fields


interface Props {
  label: string;
  error?: string;
  className?: string;
  value: string;
}

interface State {
  id: string;
}


export class GridField extends React.Component<Props, State> {

  state: State;

  constructor(props: Props) {
    super(props);
    this.state = {
      id: newId('id-gridfield-'),
    }
  }

  render() {
    return (
      <div className={`grid-field ${this.props.value ? 'hasvalue': ''} ${this.props.className || ''} ${this.props.error ? 'has-error': ''}`}>
        <label htmlFor={this.state.id}>{this.props.label}</label>
        {this.props.children}
        {this.props.error && <span className="label label-danger">{this.props.error}</span>}
      </div>
    );
  }
}